import { log } from '@/utils/log'

const SKIO_SCRIPT_URL = 'https://cdn.skio.com/scripts/shopify/planPicker/picker.js'

export function setupSkioListeners() {
	if (window.SkioPlanPicker) return

	const script = document.createElement('script')
	script.src = SKIO_SCRIPT_URL
	script.async = true
	script.onload = () => {
		log('Skio Plan Picker script loaded successfully')

		if (typeof window.SkioPlanPickerAutoInit === 'function') {
			window.SkioPlanPickerAutoInit()
		}
	}
	script.onerror = (error) => {
		console.error('Failed to load Skio Plan Picker script:', error)
	}

	document.head.appendChild(script)
}
